import { Component, Inject, OnInit } from '@angular/core';
import { Sort, SortDirection } from '@angular/material/sort';
import { Router } from '@angular/router';
import { Customer } from '../../../classes';
import { CUSTOMERS_PROVIDER_SERVICE, ICustomersProviderService } from '../../../interfaces';

@Component({
  selector: 'app-customer-table',
  templateUrl: './customer-table.component.html',
  styleUrls: ['./customer-table.component.css']
})
export class CustomerTableComponent implements OnInit {

  columns: string[] = [ 'customernumber', 'customername', 'customerphone' , 'customermail', 'controls' ];
  footerColumns: string[] = [ 'customernumber' ];

  active: string = 'customernumber';
  direction: SortDirection = 'asc';

  constructor(
    @Inject(CUSTOMERS_PROVIDER_SERVICE) public providerService: ICustomersProviderService,
    private _router: Router
  ) { }

  ngOnInit(): void {Customer
  }

  showCustomer = (customer: Customer) => this._router.navigate(['/customer-details', customer.customerid]);

  sortData(sort: Sort){
    this.active = sort.active;
    this.direction = sort.direction;
  }

}
